import tmhRequest from '@/config/tmhRequest'

export default {

    searchListOpenPlatform: function (data) {
        return tmhRequest({
            url: '/system/tmh/openplatform/searchlistopenplatform',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/system/openplatform.js